module.exports = __webpack_public_path__ + "static/scale-model-of-openstreetspgh-in-pittsburgh-pennsylvania-5dae06756fab6aea57d47206a03e95f8.png";